module.exports = __webpack_public_path__ + "media/bg.e3e45402.mp4";